export const APP_BAR_HEIGHT = {xs: "56px", sm: "64px", md: "70px"};
export const SIDEBAR_WIDTH = {expanded: 240, collapsed: 64};
export const sidebarWidth = open => open ? SIDEBAR_WIDTH.expanded : SIDEBAR_WIDTH.collapsed;
export const belowAppBar = {
    xs: `calc(100dvh - ${APP_BAR_HEIGHT.xs})`,
    sm: `calc(100dvh - ${APP_BAR_HEIGHT.sm})`,
    md: `calc(100dvh - ${APP_BAR_HEIGHT.md})`,
};
